import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, dateTime, formatError } from "../../lib/api";

const Delivery = ({ m }) => {
  if (m.delivered === undefined) return <span className="pill">pending</span>;
  if (!m.delivered) return <span className="pill failed" title={m.delivery_error || ""}>not delivered</span>;
  return <span className="pill published">{m.delivered_via === "hostinger" ? "inbox (Hostinger)" : "inbox (backup)"}</span>;
};

export const MessagesAdmin = () => {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("open");
  const load = useCallback(() => api.get("/admin/messages").then((r) => setRows(r.data)).catch((e) => toast.error(formatError(e))), []);
  useEffect(() => { load(); }, [load]);
  const mark = async (m) => {
    try { await api.post(`/admin/messages/${m.id}/handled`, { handled: !m.handled }); toast.success(m.handled ? "Marked as open" : "Marked as handled"); load(); } catch (e) { toast.error(formatError(e)); }
  };
  if (!rows) return <div className="loading">Loading…</div>;
  const shown = rows.filter((m) => filter === "all" || (filter === "open" ? !m.handled : m.handled));
  return (
    <div>
      <div className="section-title"><h2>Contact messages</h2>
        <select className="search" data-testid="messages-filter" value={filter} onChange={(e) => setFilter(e.target.value)}><option value="open">Open</option><option value="handled">Handled</option><option value="all">All</option></select></div>
      <p className="admin-note">Copies of messages sent from the Contact page. Reply from the help@availity.si inbox — the sender is set as the reply address.</p>
      <div className="message-list" data-testid="messages-list">{shown.map((m) => (
        <article className={`message-card${m.handled ? " handled" : ""}`} key={m.id} data-testid={`message-${m.id}`}>
          <header><div><b>{m.name}</b> · <a href={`mailto:${m.email}`}>{m.email}</a>{m.phone && ` · ${m.phone}`}</div><small>{dateTime(m.created_at)}</small></header>
          <div className="message-meta"><span className="pill">{m.reason}</span>{m.certification && <span className="pill">{m.certification}</span>}<Delivery m={m} /></div>
          <p>{m.message}</p>
          <button className="button secondary" data-testid={`message-handled-${m.id}`} onClick={() => mark(m)}>{m.handled ? "Mark as open" : "Mark as handled"}</button>
        </article>))}
      </div>
      {!shown.length && <div className="empty-state" data-testid="messages-empty-state">No {filter === "all" ? "" : filter} messages.</div>}
    </div>
  );
};
